import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

export default function Layout() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-paper" data-testid="layout-root">
            <Navbar />
            <main className="flex-1 pt-[92px]">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppFab />
        </div>
    );
}
